

const initialState ={

    productAdd:{
        name:"",
        category:"",
        imageurl:"",
        price:"",
        quantity:""
    },
    productList:[]
    ,
    cartItems:[]
  
}
const nextProductId = (products) => {
    let newId= Date.now();

    const maxId = products.find(product => product.id === newId);
    if(maxId){
        newId = newId + 1
    }
    return newId;
  };

const AddReducer = (state=initialState,action={}) => {
    console.log('action', action)
    switch (action.type) {

 
        case "addproduct/input":
            return {...state, productAdd:{...state.productAdd , [action?.payload.name]:action?.payload.value}};
        case "addproduct/list":
            return {...state, productList:[...state.productList, {...state.productAdd, id: nextProductId(state.productList) }], productAdd:initialState.productAdd};
        case "cart/remove":
            return {...state, cartItems:state.cartItems.filter(item => (item.id !==action.payload))};
     
        case "product/addcart":
            return {...state, productList:state.productList.map(pd=>(pd.id==action.payload.id ? {...pd,quantity:pd.quantity -1} :pd )), cartItems:  state.cartItems.find(cart=>(cart.id===action.payload.id)) ? state.cartItems.map(ct=>(ct.id==action.payload.id ? {...ct,quantity:ct.quantity +1} :ct ))   :  [...state.cartItems,{...action.payload,quantity:1}]};
        case "cart/decrease":
            return {...state, productList:state.productList.map(pd=>(pd.id==action.payload.id ? {...pd,quantity:pd.quantity +1} :pd )), cartItems:  state.cartItems.map(ct=>(ct.id==action.payload.id ? {...ct,quantity:ct.quantity -1} :ct ))   };
       
        case "addproduct/file":
            return {...state,[action?.payload.name]:action?.payload.value};
            default: return state;

    }
}

export default AddReducer